import React from "react";
import PropTypes from "prop-types";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Configuration from "../config.js";
import Icon from "./Icon";
import Modal from "./Modal";
import { getDaysInMonth, setFullYear, setMonth } from "./DateHelper";

export let FormElement = (
	{
		autoSize = false,
		validator = false,
		defaultValue = false,
		autoComplete = false,
		onChange,
		handleUpload,
		onChecked = false,
		disabled = false,
		required = false,
		autoFocus = false,
		title = false,
		value = false,
		options = [],
		step = false,
		inline = false,
		dateFormat = "dd.MM.yyyy",
		min = false,
		max = false,
		placeholder = false,
		name,
		type,
		maxLength = false
	} ) =>
{
	const validate = ( a_event ) =>
	{
		let error = false;
		
		// Validatorfunktion auf Formelement
		if ( validator !== false )
		{
			if ( validator( a_event.target.value ) !== true )
			{
				error = true;
			}
		}
		
		// Required und kein Wert
		if ( required && ( !value || value.length === 0 ) )
		{
			error = true;
		}
		a_event.target.className = error ? `validation-failed ${a_event.target.className}` : `${a_event.target.className && a_event.target.className.split( "validation-failed" )[ 1 ].trim()}`;
		
		return error;
	};
	
	let props = {
		name: name,
		onBlur: validate
	};
	
	if ( title !== false )
	{
		props[ "title" ] = title;
	}
	
	if ( value === null )
	{
		props[ "value" ] = "";
	}
	else if ( value !== false )
	{
		props[ "value" ] = value;
	}
	
	if ( autoFocus !== false )
	{
		props[ "autoFocus" ] = autoFocus;
	}
	
	if ( maxLength !== false )
	{
		props[ "maxLength" ] = maxLength;
	}
	
	if ( onChecked !== false )
	{
		props[ "onClick" ] = onChecked;
	}
	
	if ( defaultValue !== false )
	{
		props[ "defaultValue" ] = defaultValue;
	}
	
	if ( autoComplete !== false )
	{
		props[ "autoComplete" ] = autoComplete;
	}
	
	if ( step !== false )
	{
		props[ "step" ] = step;
	}
	
	if ( placeholder !== false )
	{
		props[ "placeholder" ] = placeholder;
	}
	
	if ( ( options.length === 1 && disabled ) )
	{
		props[ "value" ] = options[ 0 ].value;
	}
	
	switch ( type )
	{
		case "hidden":
			return <input onChange={onChange} {...props} type={"hidden"} autoComplete={"off"} disabled={true}/>;
		
		case "text":
			return <input onChange={onChange} {...props} type={"text"} autoComplete={"off"} disabled={disabled}/>;
		
		case "tel":
			return <input onChange={onChange} {...props} type={"tel"} autoComplete={"off"} disabled={disabled}/>;
		
		case "date":
			if ( min !== false )
			{
				props[ "minDate" ] = min;
			}
			if ( max !== false )
			{
				props[ "maxDate" ] = max;
			}
			if ( placeholder !== false )
			{
				// props[ "placeholderText" ] = placeholder;
				// delete props[ "placeholder" ];
			}
			
			// Heute wenn nichts angegeben
			let date = new Date();
			
			// Wenn ein Datum ausgewählt wurde (Datepicker oder Selectfeld)
			if ( value )
			{
				// Datepicker
				if ( typeof value === "string" )
				{
					const dateArray = value.split( "." );
					value = new Date( dateArray[ 2 ], dateArray[ 1 ] - 1, dateArray[ 0 ] );
				}
				
				if ( typeof value.getDate !== "function" )
				{
					return false;
				}
				
				// Aktueller Wert
				date = value;
			}
			
			// Initialwert
			if ( defaultValue )
			{
				if ( typeof defaultValue.value.getDate !== "function" )
				{
					return false;
				}
				
				// Aktueller Wert
				if ( !value )
				{
					date = defaultValue.value;
				}
			}
			
			// Select-Feld-Format
			if ( dateFormat.toLowerCase() === "mm.yyyy" || dateFormat.toLowerCase() === "mm.yy" )
			{
				// Wenn wichtige Informationen zum Berechnen fehlen
				if ( typeof defaultValue.startDate.getDate !== "function" || !defaultValue.toAddDate )
				{
					return false;
				}
				
				const month = date.getMonth();
				const year = date.getFullYear();
				const dayOptions = [ date.getDate() ];
				const monthOptions = [ "Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Obtober", "November", "Dezember" ];
				const yearOptions = dateFormat.toLowerCase() === "mm.yyyy"
					? [ defaultValue.value.getFullYear(), defaultValue.value.getFullYear() + 1, defaultValue.value.getFullYear() + 2 ]
					: [
						defaultValue.value.getFullYear().toString().substr( -2 ),
						( defaultValue.value.getFullYear() + 1 ).toString().substr( -2 ),
						( defaultValue.value.getFullYear() + 2 ).toString().substr( -2 )
					];
				
				return <React.Fragment>
					<select className={"col s3 l2"} disabled value={dayOptions[ 0 ]}>
						{
							dayOptions.map(
								( a_option ) =>
								{
									return <option key={`day-option-${name}-${a_option}`} value={a_option}>{a_option}</option>;
								}
							)
						}
					</select>
					<select className={"col s5 l6"}
					        disabled={defaultValue.toAddDate === "+1Y" || defaultValue.toAddDate === "+1Year"}
					        onChange={
						        a_event =>
						        {
							        switch ( defaultValue.toAddDate )
							        {
								        case "EndOfMonth":
									        const endDayInMonth = getDaysInMonth( date.getFullYear(), defaultValue.startDate.getMonth() );
									        date = setMonth(
										        new Date( date.getFullYear(), defaultValue.startDate.getMonth(), endDayInMonth ), a_event.target.value
									        );
									        onChange( date );
									        break;
								        case "+1M":
								        case "+1Month":
								        default:
									        date = setMonth(
										        new Date( date.getFullYear(), defaultValue.startDate.getMonth(), defaultValue.startDate.getDate() ),
										        defaultValue.startDate.getDate() === 1 ? parseInt( a_event.target.value ) + 1 : a_event.target.value
									        );
									        onChange( new Date( date.getFullYear(), date.getMonth(), date.getDate() - 1 ) );
									        break;
							        }
						        }
					        }
					        value={month}>
						{
							monthOptions.map(
								( a_option, a_key ) =>
								{
									// Nur zukünftige Monate anzeigen
									if ( year !== defaultValue.value.getFullYear() || a_key >= defaultValue.value.getMonth() )
									{
										return <option key={`month-option-${name}-${a_option}`} value={a_key}>{a_option}</option>;
									}
									
									return false;
								}
							)
						}
					</select>
					<select className={"col s4"}
					        onChange={
						        a_event =>
						        {
							        switch ( defaultValue.toAddDate )
							        {
								        case "EndOfMonth":
									        date = setFullYear( date, a_event.target.value );
									        onChange( new Date( date.getFullYear(), date.getMonth(), getDaysInMonth( date.getFullYear(), date.getMonth() ) ) );
									        break;
								        default:
									        onChange( setFullYear( date, a_event.target.value ) );
									        break;
							        }
						        }
					        }
					        value={year}>
						{
							yearOptions.map(
								( a_option ) =>
								{
									return <option key={`year-option-${name}-${a_option}`} value={a_option}>{a_option}</option>;
								}
							)
						}
					</select>
				</React.Fragment>;
			}
			
			if ( inline !== false )
			{
				props[ "inline" ] = true;
			}
			props[ "selected" ] = date;
			
			// Oder Datepicker-Format
			return <DatePicker onChange={onChange} {...props} disabled={disabled} isClearable showYearDropdown scrollableYearDropdown/>;
		
		case "number":
			if ( min !== false )
			{
				props[ "min" ] = parseFloat( min );
			}
			if ( max !== false )
			{
				props[ "max" ] = parseFloat( max );
			}
			return <input onChange={onChange} {...props} type={"number"} autoComplete={"off"} disabled={disabled}/>;
		
		case "password":
			return <input onChange={onChange} {...props} type={"password"} disabled={disabled}/>;
		
		case "email":
			return <input onChange={onChange} {...props} type={"email"} disabled={disabled}/>;
		
		case "url":
			return <input onChange={onChange} {...props} type={"url"} disabled={disabled}/>;
		
		case "file":
			if ( value === false )
			{
				return;
			}
			
			const fileName = value.replace( /.*[/\\]/, "" );
			if ( value.length > 0 )
			{
				props[ "title" ] = fileName;
			}
			return <div className={"btn-file"}>
				<div className={"btn right"}>
					<Icon iconName={"file"}/> <span className={"btn-text"}>auswählen</span>
					<input onChange={onChange} {...props} type={"file"} disabled={disabled}/>
				</div>
				<div className={"file-path-wrapper"}>
					<input className={"file-path"} disabled type={"text"} defaultValue={fileName}/>
				</div>
			</div>;
		
		case "checkbox":
			props[ "value" ] = value === "1";
			props[ "checked" ] = props[ "value" ] ? "checked" : "";
			
			return <input onChange={onChange} {...props} type={"checkbox"} disabled={disabled}/>;
		
		case "radio":
			return (
				options.map(
					( a_option ) =>
					{
						if ( typeof a_option === "object" )
						{
							return [
								<input onChange={onChange} {...props} checked={a_option.value === value} type={"radio"} name={`${name}`} key={`${name}-${a_option.value}`}
								       id={`${name}-${a_option.value}`}
								       value={a_option.value}/>,
								<label className={"margin-right"} key={`label-for-${name}-${a_option.value}`} htmlFor={`${name}-${a_option.value}`}>{a_option.title}</label>
							];
						}
						
						return [ <input onChange={onChange} {...props} type={"radio"} name={`${name}-${a_option}`} key={`${name}`} value={a_option}/> ];
					}
				)
			);
		
		case "textarea":
			let textareaOnChange = onChange;
			if ( autoSize === true )
			{
				const textarea = React.createRef();
				textareaOnChange = ( a_event ) =>
				{
					const currentTextarea = textarea.current;
					
					currentTextarea.style.height = "auto";
					currentTextarea.style.height = `${currentTextarea.scrollHeight}px`;
					
					onChange( a_event );
				};
				props[ "style" ] = { overflowY: "hidden" };
				props[ "ref" ] = textarea;
			}
			
			return <textarea onChange={textareaOnChange} {...props} disabled={disabled}/>;
		
		case "select":
			if ( options.length <= 1 || disabled )
			{
				props[ "disabled" ] = true;
			}
			
			return <select onChange={onChange} {...props}>
				<option value={""} disabled>Bitte auswählen</option>
				{
					options.map(
						( a_option ) =>
						{
							// if ( Array.isArray( a_option ) )
							if ( typeof a_option === "object" )
							{
								return <option key={`option-${name}-${a_option.value}`} value={a_option.value}>{a_option.title}</option>;
							}
							
							return <option key={`option-${name}-${a_option}`}>{a_option}</option>;
						}
					)
				}
			</select>;
		
		default:
			new Error( `Der angegebene Formularelementtyp "${type} ist nicht definiert.` );
			return null;
	}
};

FormElement.propTypes = {
	type: PropTypes.oneOf( [ "password", "email", "file", "select", "text", "tel", "date", "textarea", "hidden", "radio", "checkbox", "number", "url", "custom" ] ).isRequired,
	name: PropTypes.string.isRequired,
	title: PropTypes.string,
	autoFocus: PropTypes.bool,
	autoSize: PropTypes.bool,
	required: PropTypes.bool,
	disabled: PropTypes.bool,
	onChange: PropTypes.func.isRequired,
	handleUpload: PropTypes.func,
	onChecked: PropTypes.func,
	validator: PropTypes.func,
	defaultValue: PropTypes.oneOfType( [ PropTypes.string, PropTypes.number, PropTypes.object ] ),
	value: PropTypes.oneOfType( [ PropTypes.string, PropTypes.number, PropTypes.object ] ),
	options: PropTypes.oneOfType( [ PropTypes.array, PropTypes.object ] ),
	step: PropTypes.func,
	min: PropTypes.oneOfType( [ PropTypes.number, PropTypes.object ] ),
	max: PropTypes.oneOfType( [ PropTypes.number, PropTypes.object ] ),
	placeholder: PropTypes.string,
	maxLength: PropTypes.string,
	autoComplete: PropTypes.string
};

class Form extends React.Component
{
	constructor( props )
	{
		super( props );
		const fields = props.fields.map( ( a_field ) => a_field.name );
		
		this.form = React.createRef();
		this.keyCount = 0;
		
		this.state = Object.assign(
			{},
			Object.keys( fields ).reduce( ( a_object, a_key ) => ( { ...a_object, [ fields[ a_key ] ]: "" } ), {} ),
			Object.assign(
				{},
				props.values,
				this.getFormatedDate( props.values )
			)
		);
		
		this.isValid = false;
		
		this.handleSubmit = this.handleSubmit.bind( this );
		this.handleInputChange = this.handleInputChange.bind( this );
		this.handleDateChange = this.handleDateChange.bind( this );
		this.getKey = this.getKey.bind( this );
	}
	
	componentDidUpdate( a_prevProps )
	{
		if ( JSON.stringify( a_prevProps.values ) !== JSON.stringify( this.props.values ) )
		{
			this.resetState( this.props );
		}
	}
	
	resetState( a_props )
	{
		const fields = a_props.fields.map( ( a_field ) => a_field.name );
		this.setState(
			Object.assign(
				{},
				Object.keys( fields ).reduce( ( a_object, a_key ) => ( { ...a_object, [ fields[ a_key ] ]: "" } ), {} ),
				Object.assign(
					{},
					a_props.values,
					this.getFormatedDate( a_props.values )
				)
			)
		);
	}
	
	getKey()
	{
		return this.keyCount++;
	}
	
	getFormatedDate( a_values = {} )
	{
		const result = [];
		
		Object.keys( this.props.fields ).forEach(
			a_key =>
			{
				const { startFieldName = false, toAddDate = false, type, name } = { ...this.props.fields[ a_key ] };
				
				if ( type === "date" && startFieldName !== false )
				{
					const startDate = a_values[ startFieldName ];
					let date = new Date();
					
					if ( typeof startDate === "string" )
					{
						// Laufzeit
						date = this.getDateFromString( startDate, toAddDate );
						result[ name ] = date.toLocaleDateString();
					}
				}
			}
		);
		
		return result;
	}
	
	/**
	 * Wandelt das Datum in ein Objekt um
	 *
	 * @param {string} a_dateString Datum im Format 01.01.2019
	 * @param {string|boolean} a_toAddDate Hinzurechnende Tage|Monate|Jahre
	 * @return {Date}
	 */
	getDateFromString( a_dateString, a_toAddDate = false )
	{
		let date;
		const dateArray = a_dateString.split( "." );
		
		if ( dateArray.length !== 3 )
		{
			return this.props.message( "Es ist ein Fehler beim Verarbeiten des Datums aufgetretten.", "error" );
		}
		
		// zum Datum hinzurechnen
		switch ( a_toAddDate )
		{
			case "+1Y":
			case "+1Year":
				date = setFullYear( new Date( dateArray[ 2 ], parseInt( dateArray[ 1 ] ) - 1, dateArray[ 0 ] ), parseInt( dateArray[ 2 ] ) + 1 );
				date = new Date( date.getFullYear(), date.getMonth(), date.getDate() - 1 );
				break;
			case "+1M":
			case "+1Month":
				date = setMonth(
					new Date( dateArray[ 2 ], parseInt( dateArray[ 1 ] ) - 1, dateArray[ 0 ] ),
					parseInt( dateArray[ 0 ] ) === 1 ? parseInt( dateArray[ 1 ] ) + 1 : dateArray[ 1 ]
				);
				date = new Date( date.getFullYear(), date.getMonth(), date.getDate() - 1 );
				break;
			case "EndOfMonth":
				const endDayInMonth = getDaysInMonth( dateArray[ 2 ], dateArray[ 1 ] - 1 );
				date = setMonth(
					new Date( dateArray[ 2 ], parseInt( dateArray[ 1 ] ) - 1, endDayInMonth ),
					parseInt( dateArray[ 0 ] ) === endDayInMonth ? dateArray[ 1 ] : dateArray[ 1 ] - 1
				);
				break;
			case "+1D":
			case "+1Day":
				date = new Date( dateArray[ 2 ], parseInt( dateArray[ 1 ] ) - 1, dateArray[ 0 ], 24 );
				break;
			default:
				date = new Date( dateArray[ 2 ], parseInt( dateArray[ 1 ] ) - 1, dateArray[ 0 ] );
				break;
		}
		
		return date;
	}
	
	handleInputChange( event )
	{
		const target = event.target;
		const name = target.name;
		const file = target.type === "file" ? target.files[ 0 ] : false;
		let value = "";
		
		switch ( target.type )
		{
			case "checkbox":
				value = target.checked ? "1" : "";
				break;
			default:
				value = target.value;
		}
		
		this.setState(
			{
				[ name ]: value
			}
		);
		
		if ( file )
		{
			// Datei-Typ-Validierung
			const validMimeType = Object.keys( Configuration.validMimeTypes ).filter( a_key => file.type === Configuration.validMimeTypes[ a_key ] );
			if ( validMimeType.length <= 0 )
			{
				if ( typeof this.props.errorMessage === "function" )
				{
					//JLTODO dateianzeige zurücksetzen
					this.props.errorMessage( "Der Dateityp wird nicht unterstützt!", "warning", 5000 );
				}
				return;
			}
			
			// Validierung der Größe
			if ( Configuration.maximumFileSize < file.size )
			{
				if ( typeof this.props.errorMessage === "function" )
				{
					//JLTODO Input value zurücksetzen
					this.props.errorMessage( "Die Datei ist zu groß! Die maximale Dateigröße beträgt 10MB", "warning", 5000 );
				}
				return;
			}
			
			let filedata = "";
			let reader = new FileReader();
			
			reader.onload = function( e )
			{
				filedata = e.target.result;
				const parts = filedata.split( /[:;,]/ );
				filedata = parts.pop();
			};
			reader.readAsDataURL( file );
			
			// Wir benötigen 'this' um später den State aktualisieren zu können
			let self = this;
			
			reader.addEventListener( "loadend", function()
			{
				self.setState( {
					file: filedata,
					filename: file.name,
					filesize: file.size,
					mime_type: file.type
				} );
			}, false );
		}
		
		if ( typeof this.props.onChange === "function" )
		{
			this.props.onChange( this.state );
		}
		
		// Wenn im Feld eine Methode definiert wurde, dann diese jetzt aufrufen.
		Object.keys( this.props.fields ).forEach(
			( a_key ) =>
			{
				const field = this.props.fields[ a_key ];
				
				if ( field.name === target.name )
				{
					if ( typeof field.onValidChange === "function" )
					{
						field.onValidChange( value );
					}
					
					if ( typeof field.onChange === "function" )
					{
						field.onChange( value );
					}
				}
				
			}
		);
	}
	
	handleDateChange( a_date, a_name )
	{
		this.setState(
			{
				[ a_name ]: a_date
			}
		);
		
		if ( typeof this.props.onChange === "function" )
		{
			this.props.onChange( this.state );
		}
		
		// Wenn im Feld eine Methode definiert wurde, dann diese jetzt aufrufen.
		Object.keys( this.props.fields ).forEach(
			( a_key ) =>
			{
				const field = this.props.fields[ a_key ];
				
				if ( field.name === a_name )
				{
					if ( typeof field.onValidChange === "function" )
					{
						field.onValidChange( a_date );
					}
					
					if ( typeof field.onChange === "function" )
					{
						field.onChange( a_date );
					}
				}
				
			}
		);
		
	} // function handleDateChange(...)
	
	/**
	 * Formularprüfung
	 *
	 * @param a_event Event
	 * @param a_formData Formdaten
	 * @param reValidate Soll die Prüfung fortgesetzt werden?
	 *
	 * @return {boolean|Promise}
	 */
	handleSubmit( a_event, a_formData, reValidate = false )
	{
		const { validateElementsOnSubmit = true, modalTrigger = false, errorMessage } = { ...this.props };
		
		if ( !reValidate && !modalTrigger )
		{
			a_event.preventDefault();
		}
		
		// Validierung der Formelemente
		if ( validateElementsOnSubmit && !reValidate )
		{
			const lastKeys = [];
			
			this.isValid = Object.keys( this.props.fields ).every(
				a_key =>
				{
					const inputField = this.props.fields[ a_key ];
					const domElement = this.form.current[ a_key ];
					lastKeys.push( a_key );
					
					// Eingabe der Pflichtfelder überprüfen
					if ( inputField.hasOwnProperty( "required" ) && inputField.required === true && ( !a_formData[ inputField.name ] || a_formData[ inputField.name ].length === 0 ) )
					{
						Form.checkField( errorMessage, a_formData, inputField, domElement, true );
						
						// restliche Felder durchlaufen und die Meldungen ausgeben
						Object.keys( this.props.fields ).forEach(
							a_key =>
							{
								if ( lastKeys.indexOf( a_key ) !== -1 )
								{
									return;
								}
								
								const inputField = this.props.fields[ a_key ];
								const domElement = this.form.current[ a_key ];
								
								// Eingabe der Pflichtfelder überprüfen
								if ( inputField.hasOwnProperty( "required" ) && inputField.required === true && ( !a_formData[ inputField.name ] || a_formData[ inputField.name ].length === 0 ) )
								{
									Form.checkField( errorMessage, a_formData, inputField, domElement, true );
								}
							}
						);
						
						// Beendet die Schleife
						return false;
					}
					
					// Definierte Validation durchführen
					if ( inputField.hasOwnProperty( "validator" ) )
					{
						// Wir rufen die gegebenenfalls die Validierungsfunktion des Form-Elementes auf
						const validationResult = inputField.validator( a_formData[ inputField.name ] );
						if ( validationResult !== true )
						{
							// Bei einem Fehler wird eine Nachricht ausgegeben, das Feld fokussiert und die CSS-Klasse hinzugefügt.
							if ( typeof errorMessage === "function" )
							{
								errorMessage( validationResult, "warning", 5000 );
							}
							domElement.className = `validation-failed ${domElement.className}`;
							domElement.focus();
							
							// Beendet die Schleife
							return false;
						}
					}
					
					// Nächstes Feld überprüfen
					return true;
				}
			);
		}
		
		if ( this.isValid && typeof this.props.validator === "function" && !reValidate )
		{
			const validatorResult = this.props.validator( this.state );
			
			if ( typeof validatorResult !== "undefined" && typeof validatorResult.then === "function" )
			{
				const modal = this.props.modal || !!modalTrigger;
				
				// Weitere Validierung aussetzen bis die Antwort vorliegt
				if ( modal )
				{
					return validatorResult;
				}
				else
				{
					validatorResult.then(
						result =>
						{
							if ( result !== false )
							{
								this.isValid = true;
								
								// mit der Validierung fortfahren
								this.handleSubmit( a_event, a_formData, true );
							}
						}
					);
				}
				
				this.isValid = false;
			}
			else
			{
				this.isValid = validatorResult;
			}
		}
		
		if ( this.isValid )
		{
			// Bei erfolgreicher Validierung wird das Formular abgeschickt
			if ( this.props.onSubmit( a_event, a_formData ) === false )
			{
				// Wenn ein Fehler bei der Übermittlung passiert
				this.isValid = false;
			}
			
			// und der State zurückgesetzt
			// this.resetState( this.props );
		}
		
		return this.isValid;
		
	} // function handleSubmit(...)
	
	/**
	 * Form zurücksetzen
	 */
	handleCancel()
	{
		this.resetState( this.props );
		
	} // function handleCancel(...)
	
	/**
	 * Überprüft ein Feld auf Gültigkeit und übergibt ggf. eine Fehlermeldung an das Message Objekt
	 *
	 * @param {function} a_errorMessage
	 * @param {Object} a_formData
	 * @param {Object} a_inputField
	 * @param {Object} a_domElement
	 * @param {boolean} a_markElement
	 * @param {boolean} a_focusElement
	 */
	static checkField( a_errorMessage, a_formData, a_inputField, a_domElement, a_markElement = false, a_focusElement = false )
	{
		// Bei einem Fehler wird eine Nachricht ausgegeben, das Feld fokussiert und die CSS-Klasse hinzugefügt.
		if ( typeof a_errorMessage === "function" )
		{
			switch ( a_inputField.type )
			{
				case "file":
					a_errorMessage( "Bitte wählen Sie eine Dokument aus.", "warning", 5000 );
					break;
				
				case "checkbox":
					a_errorMessage( "Bitte aktivieren Sie das Feld '" + a_inputField.title + "'.", "warning", 5000 );
					break;
				
				default:
					a_errorMessage( "Bitte füllen Sie das Feld '" + a_inputField.title + "' aus.", "warning", 5000 );
					break;
			}
		}
		
		if ( a_markElement )
		{
			a_domElement.className = `validation-failed ${a_domElement.className}`;
		}
		a_focusElement && a_domElement.focus();
		
	} // function checkRequiredFields(...)
	
	// Datei wird über den Button des Input-Feldes hochgeladen
	handleFileUpload( event )
	{
		event.preventDefault();
		
		if ( typeof this.props.handleUpload === "function" )
		{
			this.props.handleUpload( this.state );
		}
		
	} // function handleFileUpload(...)
	
	render()
	{
		const {
			id = this.getKey(), disabled = false, fields = [], values = {}, submitValue = "Absenden", cancelValue = "Abbrechen", className = "",
			additionalFormHtml = false, modalClass, modalTitle, modalTrigger, onCancel, additionalModalHtml
		} = { ...this.props };
		
		let hasRequired = false;
		const modal = this.props.modal || !!modalTrigger;
		
		const form = <form key={`form_${id}`} ref={this.form} className={"form"} onSubmit={( a_event ) => this.handleSubmit( a_event, this.state )}>
			{
				Object.keys( fields ).map(
					( a_name ) =>
					{
						const {
							required,
							disabled = false,
							autoSize = false,
							autoFocus = false,
							onChecked = false,
							autoComplete = false,
							title,
							name,
							type,
							help,
							example,
							showSaveFileButton = false,
							options = false,
							validator = false,
							cleared = false,
							className = false,
							maxLength = false,
							label = "",
							reverse = false,
							additionalHtml = false,
							step = false,
							dateFormat = false,
							startFieldName = false,
							toAddDate = false,
							inline = false,
							min = false,
							max = false,
							placeholder = false
						} = { ...fields[ a_name ] };
						hasRequired = hasRequired || required;
						
						let props = {
							disabled: disabled,
							required: required,
							autoFocus: autoFocus,
							autoSize: autoSize,
							value: this.state[ name ],
							title: title,
							name: name,
							type: type
						};
						
						if ( values.hasOwnProperty( a_name ) )
						{
							props[ "defaultValue" ] = values[ a_name ];
						}
						
						if ( autoFocus !== false )
						{
							props[ "autoFocus" ] = autoFocus;
						}
						
						if ( options !== false )
						{
							props[ "options" ] = options;
						}
						
						if ( validator !== false )
						{
							props[ "validator" ] = validator;
						}
						
						if ( maxLength !== false )
						{
							props[ "maxLength" ] = maxLength;
						}
						
						if ( title !== false )
						{
							props[ "title" ] = title;
						}
						
						if ( onChecked !== false )
						{
							props[ "onChecked" ] = onChecked;
						}
						
						if ( autoComplete !== false )
						{
							props[ "autoComplete" ] = autoComplete;
						}
						
						if ( step !== false )
						{
							props[ "step" ] = step;
						}
						
						if ( placeholder !== false )
						{
							props[ "placeholder" ] = placeholder;
						}
						
						const fieldClassName = className !== false ? { className: className } : {};
						
						switch ( type )
						{
							case "custom":
								return <React.Fragment key={`form-row-${name}`}>
									<div className={className !== false ? `customField ${className}` : "customField"}>
										<label>{title}</label>
										{
											options && props[ "options" ].length > 0
												? props[ "options" ].map(
												a_option =>
												{
													if ( typeof a_option === "object" )
													{
														if ( a_option.value === props.value )
														{
															return <div key={`form-element-${props.value}`} className={"value"}>{a_option.title}</div>;
														}
													}
													return null;
												}
												)
												: <div className={"value"}>{props.value}</div>
										}
									</div>
									{additionalHtml && additionalHtml}
									{cleared && <div className={"cleared"}/>}
								</React.Fragment>;
							case "hidden":
								return <React.Fragment key={`form-row-${name}`}>
									<FormElement onChange={a_event => this.handleInputChange( a_event )} {...props}/>
									{additionalHtml && additionalHtml}
									{cleared && <div className={"cleared"}/>}
								</React.Fragment>;
							case "file":
								return <React.Fragment key={`form-row-${name}`}>
									<div {...fieldClassName}>
										<label className={"margin-bottom"}>
											<span className={"form-element-name margin-bottom"}>
												{title}
												{required && <span className={"form-element-required"}> *</span>}
											</span>
											<FormElement onChange={event => this.handleInputChange( event )} {...props}/>
											{help && <div className={"form-element-help"}>{help}</div>}
											{example && <div className={"form-element-help"}>Beispiel: <span className={"italic"}>{example}</span></div>}
											{showSaveFileButton && <button onClick={this.handleFileUpload.bind( this )}>Datei speichern</button>}
											{additionalHtml && additionalHtml}
										</label>
									</div>
									{cleared && <div className={"cleared"}/>}
								</React.Fragment>;
							case "checkbox":
								return <React.Fragment key={`form-row-${name}`}>
									{
										label.length > 0 &&
										<div className={"margin-bottom label-block"}>
											<h6>{label}</h6>
										</div>
									}
									<div {...fieldClassName}>
										<label className={`${reverse ? "reverse" : ""}`}>
											<FormElement onChange={a_event => this.handleInputChange( a_event )} {...props} />
											{
												typeof options === "object"
													? options
													: <span>{options}</span>
											}
											{required && <span className={"form-element-required"}>*</span>}
										</label>
										{help && <div className={"form-element-help"}>{help}</div>}
										{example && <div className={"form-element-help"}>Beispiel: <span className={"italic"}>{example}</span></div>}
										{additionalHtml && additionalHtml}
									</div>
									{cleared && <div className={"cleared"}/>}
								</React.Fragment>;
							case "radio":
								return <React.Fragment key={`form-row-${name}`}>
									{
										label.length > 0 &&
										<div className={"margin-bottom label-block"}>
											<h6>{label}</h6>
										</div>
									}
									<div {...fieldClassName}>
										<label className={`${reverse ? "reverse" : ""}`}>
											<span>{title}</span> {required && <span className={"form-element-required"}>*</span>}
										</label>
										<div className={"radio"}>
											<FormElement onChange={a_event => this.handleInputChange( a_event )} {...props} />
										</div>
										{help && <div className={"form-element-help"}>{help}</div>}
										{example && <div className={"form-element-help"}>Beispiel: <span className={"italic"}>{example}</span></div>}
										{additionalHtml && additionalHtml}
									</div>
									{cleared && <div className={"cleared"}/>}
								</React.Fragment>;
							case "select":
								return <React.Fragment key={`form-row-${name}`}>
									{
										label.length > 0 &&
										<div className={"margin-bottom label-block"}>
											<h6>{label}</h6>
										</div>
									}
									<div {...fieldClassName}>
										<label>
											<span className={"form-element-name"}>
												{title} {required && <span className={"form-element-required"}>*</span>}
											</span>
										</label>
										<FormElement onChange={a_event => this.handleInputChange( a_event )} {...props} />
										{help && <div className={"form-element-help"}>{help}</div>}
										{example && <div className={"form-element-help"}>Beispiel: <span className={"italic"}>{example}</span></div>}
										{additionalHtml && additionalHtml}
									</div>
									{cleared && <div className={"cleared"}/>}
								</React.Fragment>;
							case "date":
								if ( dateFormat !== false )
								{
									props[ "dateFormat" ] = dateFormat;
								}
								if ( inline !== false )
								{
									props[ "inline" ] = inline;
								}
								if ( min !== false )
								{
									props[ "min" ] = typeof min === "function" ? min( this.state ) : min;
								}
								if ( max !== false )
								{
									props[ "max" ] = typeof max === "function" ? max( this.state ) : max;
								}
								if ( startFieldName !== false )
								{
									const startDate = this.state[ startFieldName ];
									let date = new Date();
									
									if ( typeof startDate === "string" )
									{
										const dateArray = startDate.split( "." );
										const start = new Date( dateArray[ 2 ], dateArray[ 1 ] - 1, dateArray[ 0 ] );
										
										// Laufzeit
										date = this.getDateFromString( startDate, toAddDate );
										props[ "defaultValue" ] = { startDate: start, toAddDate: toAddDate, value: date };
									}
								}
								
								return <React.Fragment key={`form-row-${name}`}>
									{
										label.length > 0 &&
										<div className={"margin-bottom label-block"}>
											<h6>{label}</h6>
										</div>
									}
									<div {...fieldClassName}>
										<label>
											<span className={"form-element-name"}>
												{title} {required && <span className={"form-element-required"}>*</span>}
											</span>
										</label>
										<FormElement onChange={a_date => this.handleDateChange( a_date, name )} {...props} />
										{help && <div className={"form-element-help"}>{help}</div>}
										{example && <div className={"form-element-help"}>Beispiel: <span className={"italic"}>{example}</span></div>}
										{additionalHtml && additionalHtml}
									</div>
									{cleared && <div className={"cleared"}/>}
								</React.Fragment>;
							default:
								return <React.Fragment key={`form-row-${name}`}>
									{
										label.length > 0 &&
										<div className={"margin-bottom label-block"}>
											<h6>{label}</h6>
										</div>
									}
									<div {...fieldClassName}>
										<label>
										<span className={"form-element-name"}>
										{title} {required && <span className={"form-element-required"}>*</span>}
										</span>
										</label>
										<FormElement onChange={a_event => this.handleInputChange( a_event )} {...props} />
										{help && <div className={"form-element-help"}>{help}</div>}
										{example && <div className={"form-element-help"}>Beispiel: <span className={"italic"}>{example}</span></div>}
										{additionalHtml && additionalHtml}
									</div>
									{cleared && <div className={"cleared"}/>}
								</React.Fragment>;
						}
					}
				)
			}
			{
				// Eventuell event.preventDefault() verwenden um das Abschicken der gesamten Form zu verhindern
				additionalFormHtml && additionalFormHtml
			}
			<div className={className}>
				{hasRequired && <div className={"cleared form-has-required-fields"}>Felder mit <span className={"form-element-required"}>*</span> müssen ausgefüllt werden.</div>}
				{
					this.props.onCancel !== undefined && !modal &&
					<button type={"button"}
					        className={"secondary-color"}
					        onClick={a_event => this.props.onCancel( a_event, this.state )}
					        disabled={disabled}>{cancelValue}</button>
				}
				{
					!modal &&
					<button type={"submit"} disabled={disabled}>{submitValue}</button>
				}
			</div>
		</form>;
		
		let modalProps = {};
		
		if ( modal )
		{
			modalProps = {
				className: `baseFont ${modalClass}`,
				title: modalTitle,
				isValid: this.isValid,
				checkForm: () => this.form.current.dispatchEvent( new Event( "submit" ) )
			};
			
			if ( onCancel !== undefined )
			{
				modalProps[ "cancelForm" ] = a_event => onCancel( a_event, this.state );
			}
		}
		
		return (
			modal
				? <Modal {...modalProps}
				         trigger={
					         modalTrigger
						         ? modalTrigger
						         : <button className={"btn btn-small btn-flat hover-light-grey button"}>
							         <Icon iconName={"add"}/>
						         </button>
				         }
				         additionalModalHtml={additionalModalHtml}
				
				         footer={
					         <React.Fragment>
						         <button data-modal={"submitForm"} disabled={disabled}>{submitValue}</button>
						         <button className={"secondary-color"} data-modal={"close"} disabled={disabled}>{cancelValue}</button>
					         </React.Fragment>
				         }
				         onSubmit={( a_event, a_reValidate ) => this.handleSubmit( a_event, this.state, a_reValidate )}
				         onCancel={this.handleCancel.bind( this )}
				>
					<section className={"white"}>{form}</section>
				</Modal>
				: form
		);
	}
}

Form.propTypes = {
	fields: PropTypes.array.isRequired,
	values: PropTypes.object,
	disabled: PropTypes.bool,
	validateElementsOnSubmit: PropTypes.bool,
	onSubmit: PropTypes.func.isRequired,
	validator: PropTypes.func,
	onChange: PropTypes.func,
	errorMessage: PropTypes.func,
	handleUpload: PropTypes.func,
	onChecked: PropTypes.func,
	onCancel: PropTypes.func,
	submitValue: PropTypes.oneOfType( [ PropTypes.string, PropTypes.object, PropTypes.array ] ),
	cancelValue: PropTypes.oneOfType( [ PropTypes.string, PropTypes.object, PropTypes.array ] ),
	className: PropTypes.string,
	label: PropTypes.string,
	title: PropTypes.string,
	maxLength: PropTypes.string,
	
	additionalFormHtml: PropTypes.oneOfType( [ PropTypes.string, PropTypes.object, PropTypes.array ] ),
	
	// ModalProps
	modal: PropTypes.bool,
	modalClass: PropTypes.string,
	modalTitle: PropTypes.string,
	modalTrigger: PropTypes.object
};

export default Form;